import { MiniInterviewType } from 'src/packages/polaris/types';

/* This helper checks if we need to adjust our 24 hour promise language */
export function isWeekend() {
  // Create a new Date object which reflects the user's current timezone
  const today = new Date();

  // Get the current day of the week (0 = Sunday, 6 = Saturday) based on user's local time
  const dayOfWeek = today.getDay();

  // Check if today is Friday(5), Saturday (6), or Sunday (0)
  return dayOfWeek === 0 || dayOfWeek === 6 || dayOfWeek === 5;
}

export function isDoctorConfirmationAnOption(interviewType: MiniInterviewType) {
  return ['dxoc', 'symptoms'].includes(interviewType);
}
